import { render, staticRenderFns } from "./LaporanTukarPromo.vue?vue&type=template&id=a722a600"
import script from "./LaporanTukarPromo.vue?vue&type=script&lang=js"
export * from "./LaporanTukarPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports